import { render } from "./BankImageContainer.vue?vue&type=template&id=00fb4a75"
import script from "./BankImageContainer.vue?vue&type=script&lang=js"
export * from "./BankImageContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__